<!-- 智能问答系统 管理页面 -->
<template>
  <div class="page_content">
    <div class="filter_box flex_bet">
      <div class="flex_row">
        <el-input v-model="params.name" placeholder="文件名称" clearable></el-input>
        <el-button type="primary" style="margin-left: 10px;">搜索</el-button>
      </div>
      <div>
        <el-button type="primary" @click="dialogVisible = true">上传文件</el-button>
      </div>
    </div>
    <el-table :data="tableData" style="width: 100%" border>
      <el-table-column prop="name" label="文件名">
      </el-table-column>
      <el-table-column prop="length" label="文件大小">
        <template slot-scope="scope">
          {{scope.row.length | handleFileSize}}
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="上传时间">
        <template slot-scope="scope">
          {{scope.row.createTime | handleTime}}
        </template>
      </el-table-column>
      <el-table-column prop="createUser" label="上传人">
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="primary" icon="el-icon-view" @click="preview(scope.row)"></el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 列表模块————分页 -->
    <div style="background-color: white;width: 100%;border-radius: 0 0 10px 10px;">
      <div class="pagination-container">
        <el-pagination background :current-page.sync="params.pageNum" :page-sizes="[10,20,30]"
          :page-size="params.pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
      </div>
    </div>

    <!-- 上传文件 -->
    <el-dialog
      title="上传文件"
      :visible.sync="dialogVisible"
      width="50%">
      <div class="dialog_box">
        <div class="flex_bet flex_align_center">
          <span>产品类型：</span>
          <el-select v-model="upForm.type" clearable placeholder="请选择">
            <el-option
              v-for="item in proTypes"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>

          <span>产品系列：</span>
          <el-select v-model="upForm.series" multiple placeholder="请选择">
            <el-option
              v-for="item in proSeries"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>

          <span>产品型号：</span>
          <el-select v-model="upForm.model" multiple placeholder="请选择">
            <el-option
              v-for="item in proModels"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>

        <div class="upload flex_center">
          <el-upload
            drag
            action=""
            :on-change="handleChange"
            :on-exceed="handleExceed"
            :limit="1"
            :auto-upload="false">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            <div class="el-upload__tip" slot="tip">支持pdf,excel,word,ppt等类型的文件</div>
          </el-upload>
        </div>

      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit" :loading="uping">上 传</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import { getFilePage, getProList, uploadFile } from './smartReq'
import { getDateAndHour } from '@/utils/updateTime.js'
export default {
  components: {},
  props: [],
  data () {
    return {
      tableData: [],
      params: {
        name: '',
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      dialogVisible: false,
      upForm: {
        type: '',
        series: '',
        model: ''
      },
      proTypes: [],
      // dtoJson: {
      //   products: []
      // },
      proList: {
        proSeries: [],
        proModels: []
      },
      file: null,
      uping: false
    };
  },
  computed: {
    proSeries () {
      let list = this.proList.proSeries
      if (this.upForm.type) {
        list = list.filter(item => item.parentId == this.upForm.type)
      }
      let options = []
      list.forEach(item => {
        options.push({label: item.nameZh, value: item.id})
      })
      return options
    },
    proModels () {
      let list = this.proList.proModels
      let arr = []
      if (this.upForm.series.length) {
        this.upForm.series.forEach(id => {
          arr = arr.concat(list.filter(item => item.parentId == id))
        })
      }
      let options = []
      arr.forEach(item => {
        options.push({label: item.nameZh, value: item.id})
      })
      return options
    }
  },
  filters: {
    handleTime (val) {
      return getDateAndHour(val)
    },
    handleFileSize (val) {
      return (val/1024/1024).toFixed(2) + ' mb'
    }
  },
  mounted () {
    this.initPage()
    this._getProList()
  },
  methods: {
    preview (row) {
      open('https://file-test.gpdcloud.net/scs/'+ row.savePan)
    },
    handleExceed () {
      // 超出最大数
    },
    handleChange (file, fileList) {
      console.log(file)
      this.file = file
    },
    submit () {
      console.log(this.upForm)
      let products = []
      if (this.upForm.type) {
        const obj = this.proList.proTypes.find(item => item.id == this.upForm.type)
        products.push(obj)
      }
      if (this.upForm.series) {
        this.upForm.series.forEach(id => {
          const obj = this.proList.proSeries.find(item => item.id == id)
          products.push(obj)
        })
      }
      if (this.upForm.model) {
        this.upForm.model.forEach(id => {
          const obj = this.proList.proModels.find(item => item.id == id)
          products.push(obj)
        })
      }
      console.log(products)
      this.uping = true

      uploadFile(this.file, {products}).then(res => {
        this.uping = false
        console.log(res)
        if (res.resultCode == 1001) {
          this.file = null
          this.dialogVisible = false
          this.$message.success('上传成功')
          this.initPage()
        }else {
          this.$message.warning(res.resultMessage)
        }
      })
    },
    _getProList () {
      getProList().then(res => {
        console.log('产品列表：', res)
        if (res.resultCode == 1001) {
          this.proList = res.resultModel
         
          let proTypes = []
          res.resultModel.proTypes.forEach(item => {
            proTypes.push({label: item.nameZh, value: item.id})
          });
          this.proTypes = proTypes
        }
      })
    },
    handleSizeChange (val) {
      this.params.pageSize = val
      this.initPage()
    },
    handleCurrentChange (val) {
      this.params.pageNum = val
      this.initPage()
    },
    initPage () {
      getFilePage(this.params).then(res => {
        console.log('文件列表：', res)
        if (res.resultCode == 1001) {
          this.tableData = res.resultModel.list
          this.total = res.resultModel.total
        }
      })
    }
  }
}
</script>

<style lang='scss' scoped>
.page_content {
  padding: 20px;
  background-color: #fff;
  min-height: 100%;
  border-radius: 4px;
}
.filter_box {
  margin-bottom: 20px;
}

.upload {
  padding: 20px;
}
</style>
